export { default } from '../features/auth/register';
